import pushToDataLayer, { TrackingEvent } from './pushToDataLayer';
import { buildUserDataEvent } from './buildUserDataEvent';
import logger from '../logger';

const trackUserData = (email: string): void => {
  try {
    const event = buildUserDataEvent({ user_email: email });
    pushToDataLayer({ type: TrackingEvent.USER_DATA, ...event });
  } catch (error: unknown) {
    logger.error(`Failed to track event: ${error}`);
  }
};

export default trackUserData;
